import { FilterShiftType } from "./time-keeping-page-def";

export const shiftTypeOptions: { label: string; value: FilterShiftType }[] = [
	{ label: 'Все', value: 'all' },
	{ label: 'Дневная', value: 'day' },
	{ label: 'Ночная', value: 'night' }
]
